type TypeGuardType<TGuard> = TGuard extends (value: unknown) => value is infer T ? T : never

export namespace Assert {
    const getError = (message?: string) => new Error(message ? `Assertion failed: ${message}` : 'Assertion failed!')

    /** Check that a given condition is truthy. */
    export function check(condition: boolean, message?: string): void {
        if (!condition) {
            throw getError(message)
        }
    }

    export function checkIs<T>(
        guard: (value: unknown) => value is T,
        value: unknown,
        message?: string
    ): value is TypeGuardType<typeof guard> {
        const result: boolean = guard(value)
        if (!result) {
            throw getError(message)
        }

        return result
    }

    /** Check that a given value is defined. */
    export function checkDefined<T>(value: T | undefined | null, message?: string): asserts value is T {
        const result = value !== undefined && value !== null
        if (!result) {
            throw getError(message)
        }
    }

    /** Check that a given string is defined and not empty. */
    export function checkStringNotEmpty(value: string | undefined | null, message?: string): asserts value is string {
        const result = value !== undefined && value !== null && value.length > 0
        if (!result) {
            throw getError(message)
        }
    }
}
